// 외부 링크 스킴 가드(G8): 사용자/외부 입력 URL을 href로 렌더하기 전 http(s)/mailto만 허용.
// javascript:·data:·vbscript: 등은 클릭 시 XSS(예: localStorage JWT 탈취)로 이어질 수 있어 차단.
// 안전하면 정규화된 URL 문자열, 아니면 null 반환 → 호출부에서 null이면 링크 미렌더.
const ALLOWED = ['http:', 'https:', 'mailto:'];

export function safeUrl(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const s = raw.trim();
  try {
    // 상대경로 해석 base 제공(절대 URL이면 base 무시). 스킴만 보고 판정.
    const u = new URL(s, window.location.origin);
    return ALLOWED.includes(u.protocol) ? s : null;
  } catch {
    return null;
  }
}

export default safeUrl;
